import { LOAD_FLAGS } from 'model/flags';
import { loadFlags } from 'sdk/flags';
import { takeEvery } from 'redux-saga/effects';
import { callAction, ORM } from '../util';

export const loadFlagsAction = callAction({
  api: loadFlags,
  dataName: ORM,
  type: LOAD_FLAGS,
});

export default function* saga() {
  yield takeEvery(LOAD_FLAGS.ACTION, loadFlagsAction);
}
